<!-- eslint-disable vue/no-v-html -->
<style lang="scss">
.futures-footer {
  padding: 0.5rem 1rem;
  line-height: 6rem;
  font-size: 5rem;
  font-weight: bold;

  &__datetime {
    display: block;
    margin-right: 2rem;
    font-size: 5rem;
  }

  &__future-wrapper {
    padding-left: 2.7rem;
    border-right: 3px solid color(text2);

    span {
      display: inline-block;
    }

    .flag-icon {
      height: 3rem;
      width: auto;
      margin-right: 1rem;
    }

    .month {
      margin-right: 1rem;
      color: color(text-light);
    }
  }

  &__exchange-row {
    &:not(:last-child) {
      padding-right: 3rem;
    }
  }
}
</style>

<template>
  <div class="futures-footer w-full flex flex-row items-center justify-start">
    <div
      class="futures-footer__datetime"
    >
      <span style="white-space: nowrap;">{{ datetime }}</span>
    </div>
    <v-spinner
      :show="loading"
    />
    <v-marquee
      v-if="hasData"
      :duration="footerSpeed"
    >
      <div class="flex flex-row items-center">
        <div
          v-for="(future, index) in futures"
          :key="future.product"
          :index="index"
          class="futures-footer__future-wrapper flex flex-row items-center"
        >
          <span class="product">{{ future.product }}:</span>
          <div
            v-for="exchange in future.exchanges"
            :key="exchange.exchange"
            class="futures-footer__exchange-row flex flex-row items-center px-5"
          >
            <img
              :src="flagAsset(exchange.exchange)"
              class="flag-icon"
            >
            <span class="exchange">{{ exchange.exchange }}</span>
            <div
              v-for="month in exchange.months"
              :key="month.month"
              class="flex flex-row items-center px-5"
            >
              <span class="month">{{ month.month }}</span>
              <span class="bid">{{ month.bid }}</span>
              <span>/</span>
              <span class="ask">{{ month.ask }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-marquee>
  </div>
</template>

<script>
import config from '@/config';
import {flagAsset} from '@/helpers';
import {mapGetters} from 'vuex';
import moment from 'moment';

export default {
  name: 'VFooter',
  data() {
    return {
      loading: true,
      datetime: '',
      footerSpeed: config.footerSpeed,
    };
  },
  computed: {
    ...mapGetters({
      loadingFutures: 'loadingFutures',
      apiData: 'futureData',
    }),
    hasData() {
      return Object.keys(this.apiData).length > 0;
    },
    futures() {
      if (!this.hasData) {
        return [];
      }

      return this.apiData.products.map((product) => {
        const productData = this.apiData.data[product];

        const exchanges = Object.keys(productData).map((exchange) => {
          const exchangeData = productData[exchange];

          if (exchangeData === null) {
            return null;
          }

          const exchangeBidAsk = Object.keys(exchangeData).map((month) => {
            const monthData = exchangeData[month];

            if (monthData.ask === null || monthData.bid === null) {
              return null;
            }

            return {
              month: month.substring(0, 3),
              bid: monthData.bid,
              ask: monthData.ask,
            };
          }).filter(Boolean);

          if (exchangeBidAsk.length === 0) {
            return null;
          }

          return {
            exchange,
            months: exchangeBidAsk,
          };
        }).filter(Boolean);

        if (exchanges.length === 0) {
          return null;
        }

        return {
          product,
          exchanges,
        };
      }).filter(Boolean);
    },
  },
  watch: {
    loadingFutures() {
      this.loading = this.loadingFutures && !this.hasData;
    },
  },
  created() {
    this.setDateTime();
    setInterval(this.setDateTime, 1000);
  },
  methods: {
    flagAsset,
    setDateTime() {
      this.datetime = moment().format('DD MMM YYYY HH:mm');
    },
  },
};
</script>
